import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
import genericActions from "../../redux/generic/actions";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import rechargeActions from "../../redux/recharge/actions";
import ToastAlert from "../../components/utils/ToastAlert";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../../redux/auth/actions";

const { bulkRechargeReq, resetMessage } = rechargeActions;
const { getPlan } = genericActions;
const { getUserDataByToken } = authActions;
const MAX_RECORDS = 100;


const BulkRecharge = () => {
  const dispatch = useDispatch();
  const { planList, getPlanLoading } = useSelector((state) => state.generic);
  const { bulkRechargeFData,
    bulkRechargeLoading,
    bulkRechargeMessage,
    bulkRechargeError, } = useSelector((state) => state.recharge);
  const [selectedPlan, setSelectedPlan] = useState({})
  const [inputMSISDNList, setInputMSISDNList] = useState([]);
  const [inputSimListError, setInputMSISDNListError] = useState('');
  const [invalidMSISDNs, setInvalidMSISDNs] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      planId: "",
      months: 1,
      msisdnData: ''
    },
  });

  const watchPlanId = watch('planId');

  useEffect(() => {
    if (bulkRechargeMessage) {
      ToastAlert({ type: "success", text: bulkRechargeMessage });
      handleReset();
      dispatch(getUserDataByToken());
    }

    if (bulkRechargeError) {
      ToastAlert({ type: "error", text: bulkRechargeError });
    }
  }, [bulkRechargeMessage, bulkRechargeError]);


  useEffect(() => {
    if (!watchPlanId || !planList?.length) {
      setSelectedPlan(null);
      return;
    }

    const planData = planList.find(
      (item) => item?.PlanID == watchPlanId
    );

    if (!planData) {
      setSelectedPlan(null);
      return;
    }

    const planAmount = Number(planData?.PlanAmount || 0);
    const dealerCostAmount = Number(planData?.DealerCost || 0);
    const totalQantity = Number(inputMSISDNList?.length || 0) - Number(invalidMSISDNs?.length || 0);
    const totalPlanAmount = totalQantity * planAmount;
    const totalDealerCost = totalQantity * dealerCostAmount;

    setSelectedPlan({
      ...planData,
      totalQantity,
      totalPlanAmount,
      totalDealerCost,
    });
  }, [watchPlanId, planList, inputMSISDNList]);

  useEffect(() => {
    dispatch(getPlan({ ActionType: 2, Month: 1 }))
    return () => {
      dispatch(resetMessage());
    };
  }, [])

  const removeExtraSpaces = (str) => {
    return str.replace(/\s+/g, ' ').trim();
  };
  const uniqArray = (array) => {
    return [...new Set(array)];
  };


  const handleTextareaChange = (val) => {
    clearErrors('msisdnData')
    setInputMSISDNListError('')

    const dataArr = val.trim() !== '' ? val.trim().split('\n') : [];
    const previewdata = dataArr.map(item => removeExtraSpaces(item)).filter(item => item !== ''); //remove extra spaces and empty lines
    const uniqueSerialNumberArr = uniqArray(previewdata);

    if (uniqueSerialNumberArr.length !== previewdata.length) {
      setInputMSISDNListError('Data contains duplicate Serial number')
    }

    // limit check
    if (previewdata.length > MAX_RECORDS) {
      setInputMSISDNListError(`Maximum ${MAX_RECORDS} records allowed.`)
    }

    setInputMSISDNList(previewdata)
  };


  const getMSISDNErrors = (value) => {
    return value
      .split(/\r?\n/)
      .map((line, index) => {
        // Ignore trailing spaces while validating
        const number = line.trimEnd();

        // Ignore empty rows
        if (!number) {
          return null;
        }

        let error = "";

        // Alphabet check
        if (/[a-zA-Z]/.test(number)) {
          error = "Alphabets are not allowed";
        }
        // Space check
        else if (/\s/.test(number)) {
          error = "Spaces are not allowed";
        }
        // Special character check
        else if (/[^0-9]/.test(number)) {
          error = "Special characters are not allowed";
        }
        // Length check
        else if (number.length !== 10) {
          error = "MSISDN must contain exactly 10 digits";
        }

        return error
          ? {
            line: index + 1,
            number,
            error,
          }
          : null;
      })
      .filter(Boolean);
  };

  const onSubmit = (data) => {
    if (invalidMSISDNs.length > 0 || inputSimListError) {
      ToastAlert({ type: "error", text: inputSimListError || 'Please resolve all MSISDN validation errors before submitting.' });
      return;
    }

    const msisdnList = inputMSISDNList && inputMSISDNList.length > 0 && inputMSISDNList.map((item) => {
      return {
        "mobileNumber": item,
      };
    });

    const payload = {
      "planId": Number(data?.planId),
      "months": Number(data?.months),
      "rechargeType": 2,
      "items": msisdnList,
    }

    dispatch(bulkRechargeReq(payload))
  };

  const handleReset = () => {
    reset();
    setInvalidMSISDNs([]);
    setInvalidMSISDNs([])
    setInputMSISDNListError('')
  };

  return (
    <CardLayout title="Bulk Recharge" icon="fas fa-layer-group">
      <div className="row">
        {/* Left Side */}
        <div className="col-lg-3 left-panel">
          <div className="quick-links">
            <div className="d-flex justify-content-between">
              <button type="button" onClick={() => { }}>
                <h5 className="quick-title">Plan Summary</h5>
                {<div className="title-line"></div>}
              </button>
            </div>

            <div className="d-flex flex-column gap-3">

              {/* Plan Price */}
              {/* <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-tag text-primary"></i>
                  <span className="text-dark fw-semibold">Plan Price</span>
                </div>
                <span className="text-primary fw-bold">
                  ${twoDigitDecimal(selectedPlan?.PlanAmount)}
                </span>
              </div> */}

              {/* Total Quantity */}
              <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-layer-group text-primary"></i>
                  <span className="text-dark fw-semibold">Total Quantity</span>
                </div>
                <span className="text-primary fw-bold">
                  {selectedPlan?.totalQantity || 0}
                </span>
              </div>

              {/* Total Plan Price */}
              {/* <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-calculator text-primary"></i>
                  <span className="text-dark fw-semibold">Total Plan Price</span>
                </div>
                <span className="text-primary fw-bold">
                  ${twoDigitDecimal(selectedPlan?.totalPlanAmount)}
                </span>
              </div> */}

              {/* Dealer Cost */}
              <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-hand-holding-dollar text-primary"></i>
                  <span className="text-dark fw-semibold">Dealer Cost</span>
                </div>
                <span className="text-primary fw-bold">
                  ${twoDigitDecimal(selectedPlan?.DealerCost)}
                </span>
              </div>

              {/* Total Dealer Cost */}
              <div className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-money-check-dollar text-primary"></i>
                  <span className="text-dark fw-semibold">Total Dealer Cost</span>
                </div>
                <span className="text-primary fw-bold">
                  ${twoDigitDecimal(selectedPlan?.totalDealerCost)}
                </span>
              </div>

              {selectedPlan?.PlanCode && <div className="d-flex justify-content-between ">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>SKU</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanCode}</span>
              </div>}

              {selectedPlan?.PlanDesc &&<div className="">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>Plan Description</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanDesc}</span>
              </div>}

            </div>

          </div>
        </div>

        <div className="col-lg-9">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Plan */}
              <div
                className="col-lg-4 mb-2 order-lg-1"
              >
                <label className="form-label fw-semibold">
                  Plan <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.planId ? "is-invalid" : ""
                    }`}
                  disabled={getPlanLoading}
                  {...register("planId", {
                    required: "Plan is required",
                  })}
                >

                  <>
                    <option value="">Select Plan</option>
                    {planList?.map((item) => (
                      <option key={item?.PlanID} value={item?.PlanID}>
                        {item?.PlanName}
                      </option>
                    ))}
                  </>
                </select>

                <div className="invalid-feedback"> {errors.planId?.message} </div>
              </div>

              {/* Months */}
              <div className="col-lg-4 mb-2 order-lg-1" >
                <label className="form-label fw-semibold">
                  Month <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-control ${errors.months ? "is-invalid" : ""
                    }`}
                  disabled
                  {...register("months", {
                    required: "Month is required",
                  })}
                >
                  <>
                    <option value="">Select Month</option>
                    <option value="1">1</option>
                  </>
                </select>

                <div className="invalid-feedback"> {errors.months?.message} </div>
              </div>

              {/* MSISDN */}
              <div className="col-lg-12 order-lg-4">
                <label className="form-label fw-semibold">
                  MSISDN <span className="text-danger">*</span>
                  <span
                    className="position-relative ms-2 info-icon-wrapper"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fas fa-info-circle text-primary fs-5 info-icon-text" />

                    <div className="dealer-confirm-popup position-absolute bg-white border rounded shadow-sm py-2">
                      <ul className="mb-0 ps-4 custom-info-list">
                        <li className="mb-1">
                          MSISDN must contain 10 digits only.
                        </li>

                        <li className="mb-1">
                          Only{" "} <span className="text-primary fw-semibold"> {MAX_RECORDS} </span>{" "}
                          MSISDNs are allowed per submission.
                        </li>

                        <li className="mb-1">
                          Press enter to move to the next MSISDN.
                        </li>

                        <li>
                          For multiple MSISDNs, enter one MSISDN per line:
                          <div className="bg-light rounded p-2 mt-1 me-2">
                            <code className="d-block">1234567890</code>
                            <code className="d-block">1234567890</code>
                            <code className="d-block">......</code>
                            <code className="d-block">......</code>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </span>
                </label>
                <textarea
                  className={`form-control mb-1 ${(errors.msisdnData || invalidMSISDNs.length > 0) ? "is-invalid" : ""}`}
                  id="data"
                  rows="10"
                  style={{ resize: "none" }}
                  {...register("msisdnData", {
                    required: "MSISDN is required",
                  })}
                  placeholder={`Example:\n1234567890\n1234567890\n. . . . .\n. . . . .`}
                  onChange={(e) => {
                    const value = e.target.value;
                    const invalidList = getMSISDNErrors(value);
                    setInvalidMSISDNs(invalidList);
                    handleTextareaChange(value);
                  }}
                />

                {/* Individual MSISDN errors */}
                {invalidMSISDNs.length > 0 && (
                  <div className="mt-2">
                    {invalidMSISDNs.map((item) => (
                      <div
                        key={item.line}
                        className="text-danger small d-flex align-items-center gap-2 mb-1"
                      >
                        <i className="fa-solid fa-circle-xmark"></i>

                        <span>
                          <strong>Line {item.line}:</strong>{" "}
                          <strong>{item.number}</strong> — {item.error}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {errors.msisdnData && (<div className="invalid-feedback"> {errors.msisdnData.message} </div>)}
                {inputSimListError && (<div className="text-danger small mt-1"> <i className="fa-solid fa-circle-xmark me-1"></i> {inputSimListError} </div>)}
              </div>
              {/* Buttons */}
              <div className="col-lg-4 d-flex align-items-end order-lg-1" style={{ height: '70px' }}>
                <div className="d-flex gap-3">
                  <Button
                    title="Recharge"
                    buttonType="submit"
                    variant="primary"
                    loading={bulkRechargeLoading}
                    icon={<i className="ri-flashlight-line me-1"></i>}
                  />

                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    onClick={handleReset}
                    disable={bulkRechargeLoading}
                    icon={<i className="ri-refresh-line me-1"></i>}
                  />
                </div>
              </div>



            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};
export default BulkRecharge;
